import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import logo from "../../Images/company-logo.png";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={logo} alt="Company Logo" width="180" height="50" />
        </div>
        <div className="footer-social">
          <h4>Follow us</h4>
          <div className="social-icons">
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedinIn} className="icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
